import { render, staticRenderFns } from "./wxwl-shangh.vue?vue&type=template&id=15ef1220"
import script from "./wxwl-shangh.vue?vue&type=script&lang=js"
export * from "./wxwl-shangh.vue?vue&type=script&lang=js"
import style0 from "./wxwl-shangh.vue?vue&type=style&index=0&id=15ef1220&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports